/**
 * Normaliza lo que teclea la pistola de codigo de barras.
 *
 * El formato es ADC000034: solo letras y digitos, sin separadores. Es a
 * proposito, porque el lector emula un teclado US QWERTY y con otra
 * distribucion los simbolos llegan cambiados (el guion salia como "'").
 *
 * Esta funcion queda como red de contencion: cubre las etiquetas impresas
 * con el formato viejo (ADC-000034) y las entradas con espacios,
 * minusculas o ceros de menos.
 *
 * Debe quedar alineado con Backend/src/utils/codigoBarra.js
 */

const PREFIJO = "ADC";
const DIGITOS = 6;

export const canonizarCodigoBarra = (valor) => {
  const limpio = String(valor ?? "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

  if (!limpio) return null;

  const m = limpio.match(new RegExp("^" + PREFIJO + "([0-9]{1," + DIGITOS + "})$"));
  if (!m) return null;

  return PREFIJO + m[1].padStart(DIGITOS, "0");
};
